var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('router-view',{on:{"click":_vm.resetTimeout}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }